// src/pages/ProcessPage.js
import React from 'react';
import Process from '../components/Process';
import FAQ from '../components/FAQ';

function ProcessPage() {
  return (
    <div className="pt-24">
      <Process />
      <FAQ />
    </div>
  );
}

export default ProcessPage;